import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComparisonType } from '@iotv/iotv-v3-types';
import { Stack, Switch, TextField, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeBySignal = (props) => {
    const { updateParams: setParamsInParent, keyPress, index, children, selected } = props;
    const [valueFrom, setValueFrom] = useState('-100');
    const [valueTo, setValueTo] = useState('100');
    const [active, setActive] = useState(true);
    const handleFrom = (e) => {
        let value = e.target.value;
        if (value === '') {
            value = '';
        }
        const stringRegex = /[a-zA-Z]/;
        const hasLetter = stringRegex.test(value);
        if (hasLetter) {
            return;
        }
        // check .
        const regex = /\./g;
        const matches = value.match(regex);
        const dotCount = matches ? matches.length : 0;
        if (dotCount < 2) {
            setValueFrom(value);
        }
    };
    const handleTo = (e) => {
        let value = e.target.value;
        if (value === '') {
            value = '';
        }
        const stringRegex = /[a-zA-Z]/;
        const hasLetter = stringRegex.test(value);
        if (hasLetter) {
            return;
        }
        // check .
        const regex = /\./g;
        const matches = value.match(regex);
        const dotCount = matches ? matches.length : 0;
        if (dotCount < 2) {
            setValueTo(value);
        }
    };
    const handleSwitch = () => {
        setActive(!active);
    };
    useEffect(() => {
        const attKey = active ? 'snr' : 'rssi';
        if (valueFrom === '' || valueTo === '' || !selected) {
            setParamsInParent(undefined, index);
        }
        else {
            setParamsInParent([
                { key: attKey, value: parseInt(valueFrom), predicate: ComparisonType.GREATER_EQUAL },
                { key: attKey, value: parseInt(valueTo), predicate: ComparisonType.LESS_EQUAL },
            ], index);
        }
    }, [valueFrom, valueTo, active, selected]);
    return (_jsxs(Toolbar, { style: { maxHeight: '100px' }, children: [children, _jsxs("div", { style: { paddingTop: '10px', paddingBottom: '10px' }, children: [_jsxs(Stack, { direction: "row", spacing: 1, sx: { justifyContent: 'center', alignItems: 'center' }, children: [_jsx(TextField, { value: valueFrom, size: 'small', variant: 'outlined', onChange: handleFrom, onKeyDown: keyPress }), _jsx("p", { children: "to" }), _jsx(TextField, { value: valueTo, size: 'small', variant: 'outlined', onChange: handleTo, onKeyDown: keyPress })] }), _jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: 'center' }, children: [_jsx(Typography, { children: "RSSI" }), _jsx(Switch, { size: "small", checked: active, onChange: handleSwitch }), _jsx(Typography, { children: "SNR" })] })] })] }));
};
